export default {
    anchor_point: {
        name: "Anchor Point",
        url: "fireai_wildfire/anchor_point",
    },
    archaeological_site: {
        name: "Archaeological Site",
        url: "fireai_wildfire/archaeological_site",
    },
    aviation_fuel_cache: {
        name: "Aviation Fuel Cache",
        url: "fireai_wildfire/aviation_fuel_cache",
    },
    bad_comms: {
        name: "Bad Comms",
        url: "fireai_wildfire/bad_comms",
    },
    bad_dip_site: {
        name: "Bad Dip Site",
        url: "fireai_wildfire/bad_dip_site",
    },
    beehive: {
        name: "Beehive",
        url: "fireai_wildfire/beehive",
    },
    bomber_target: {
        name: "Bomber Target",
        url: "fireai_wildfire/bomber_target",
    },
    bucket_site: {
        name: "Bucket Site",
        url: "fireai_wildfire/bucket_site",
    },
    campsite: {
        name: "Campsite",
        url: "fireai_wildfire/campsite",
    },
    closure: {
        name: "Closure",
        url: "fireai_wildfire/closure",
    },
    danger_animal: {
        name: "Danger Animal",
        url: "fireai_wildfire/danger_animal",
    },
    danger_tree: {
        name: "Danger Tree",
        url: "fireai_wildfire/danger_tree",
    },
    danger_tree_assessed: {
        name: "Danger Tree Assessed",
        url: "fireai_wildfire/danger_tree_assessed",
    },
    danger_tree_fallen: {
        name: "Danger Tree Fallen",
        url: "fireai_wildfire/danger_tree_fallen",
    },
    drone_launch_site: {
        name: "Drone Launch Site",
        url: "fireai_wildfire/drone_launch_site",
    },
    escape_route: {
        name: "Escape Route",
        url: "fireai_wildfire/escape_route",
    },
    first_aid_station: {
        name: "First Aid Station",
        url: "fireai_wildfire/first_aid_station",
    },
    gear_cache: {
        name: "Gear Cache",
        url: "fireai_wildfire/gear_cache",
    },
    gear_drop: {
        name: "Gear Drop",
        url: "fireai_wildfire/gear_drop",
    },
    general_hazard: {
        name: "General Hazard",
        url: "fireai_wildfire/general_hazard",
    },
    good_comms: {
        name: "Good Comms",
        url: "fireai_wildfire/good_comms",
    },
    good_dip_site: {
        name: "Good Dip Site",
        url: "fireai_wildfire/good_dip_site",
    },
    helipad: {
        name: "Helipad",
        url: "fireai_wildfire/helipad",
    },
    intended_burn_area: {
        name: "Intended Burn Area",
        url: "fireai_wildfire/intended_burn_area",
    },
    jump_site: {
        name: "Jump Site",
        url: "fireai_wildfire/jump_site",
    },
    lookout: {
        name: "Lookout",
        url: "fireai_wildfire/lookout",
    },
    outhouse: {
        name: "Outhouse",
        url: "fireai_wildfire/outhouse",
    },
    parking_lot: {
        name: "Parking Lot",
        url: "fireai_wildfire/parking_lot",
    },
    pipeline_crossing: {
        name: "Pipeline Crossing",
        url: "fireai_wildfire/pipeline_crossing",
    },
    pump_site: {
        name: "Pump Site",
        url: "fireai_wildfire/pump_site",
    },
    pumpkin: {
        name: "Pumpkin",
        url: "fireai_wildfire/pumpkin",
    },
    rain_gauge: {
        name: "Rain Gauge",
        url: "fireai_wildfire/rain_gauge",
    },
    road_block: {
        name: "Road Block",
        url: "fireai_wildfire/road_block",
    },
    safety_zone: {
        name: "Safety Zone",
        url: "fireai_wildfire/safety_zone",
    },
    sensitive_habitat: {
        name: "Sensitive Habitat",
        url: "fireai_wildfire/sensitive_habitat",
    },
    staging: {
        name: "Staging",
        url: "fireai_wildfire/staging",
    },
    stilwell: {
        name: "Stilwell",
        url: "fireai_wildfire/stilwell",
    },
    tower: {
        name: "Tower",
        url: "fireai_wildfire/tower",
    },
}
